export default __webpack_public_path__ + "static/media/gallery_06.7f0d0361.jpg";